import BlogWrapper from '@/components/blog';
import { BlogBanner } from '@/components/blog/blog-banner';
import { CMSSeo } from '@/components/cms-seo';
import { BLOG_SEO } from '@/constants/seo.constants';
import { useEffect } from 'react';

const BlogPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <CMSSeo
        data={{
          seo_page_title: BLOG_SEO.title,
          seo_description: BLOG_SEO.description,
          seo_keywords: BLOG_SEO.seo_keywords,
        }}
      />
      <div className="">
        <BlogBanner />
        <BlogWrapper />
      </div>
    </>
  );
};

export { BlogPage };
